var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"main-container",attrs:{"id":"app"}},[(_vm.$store.getters.UseBaseLayout)?_c('page-header'):_vm._e(),_c('router-view'),(_vm.$store.getters.UseBaseLayout)?_c('page-footer'):_vm._e(),_c('BackToTop')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }